import React, { useCallback, useState, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import {
  FormControl
} from 'react-bootstrap'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import UserGroupUsers from 'components/UserGroupUsers'
import User from 'components/User'
import KanBoIcon from 'components/KanBoIcon'
import requestRemoveUserFromGroup from '../../sagas/requestRemoveUserFromGroup'
import { useDispatch, useSelector } from 'react-redux'
import { useBoardContext } from 'dataProviders/Board'
import useGetData from 'hooks/useGetData'
import ControlledUser from 'components/ControlledUser'

type Props = {
  id: number
  userComponent?: React.ComponentType<any>
}

const UserGroup: React.FC<Props> = ({
  id,
  userComponent: UserComponent = ControlledUser
}) => {
  const [keyword, setKeyword] = useState('')

  const boardContext = useBoardContext()

  const dispatch = useDispatch()

  const name = useSelector<any, string | undefined>(state => state.kanbo.userGroups[id]?.name)

  const args = useMemo(() => ({
    groupId: id
  }), [id])
  const {
    data,
  }: {
    data: any
  } = useGetData('IsGroupEditable', args)

  const handleSearchInputChange = useCallback((event) => {
    setKeyword(event.target.value)
  }, [])

  const renderUser = useCallback((props) => {
    const _menu = (data && data.Value) ? [{
      icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
      title: <FormattedMessage id='USER_REMOVE_FROM_GROUP' />,
      onClick: () => {
        dispatch(requestRemoveUserFromGroup({
          boardId: boardContext.id,
          userId: props.id,
          userGroupId: id
        }))
      }
    }] : undefined

    return (
      <UserComponent
        {...props}
        menu={_menu}
      >
        {({ isActive, ...userProps }) =>
          <User
            {...userProps}
            isActive={isActive}
            draggable={isActive}
          />
        }
      </UserComponent>
    )
  }, [data, boardContext, id])


  return (
    <LeftSidebarView
      title={name}
    >
      <ViewBody className='m-b-5'>
        <FormattedMessage id='USERS_SEARCH_HINT'>
          {formattedMessage =>
            <FormControl
              type='text'
              placeholder={formattedMessage}
              value={keyword}
              onChange={handleSearchInputChange}
            />
          }
        </FormattedMessage>
      </ViewBody>
      <UserGroupUsers
        id={id}
        keyword={keyword}
        userComponent={renderUser}
      />
    </LeftSidebarView>
  )
}

export default UserGroup
